<!--begin::Loyalty Offers List-->
<div *ngIf="offers && offers.length" class="row section-list">
  <div class="col-md-12">
    <h3 class="list-tiltle">{{ 'OFFER.PLURAL' | translate }}</h3>
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide *ngFor="let offer of (offers);">
        <sng-offer-card [offer]="offer" type="{{type}}" (mousedown)="mousedown()" (mousemove)="mousemove()" (mouseup)="mouseup(offer)"></sng-offer-card>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>
<!--end::Loyalty Offers List-->

<!--begin::Microcredit Campaign Modal-->
<ng-template #offerModal let-c="close" let-d="dismiss">
  <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <sng-loyalty_offer-single [offer]="offer"></sng-loyalty_offer-single>
</ng-template>
<!--end::Microcredit Campaign Modal-->